import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getCountry } from "../../redux/Apislices/countrySlice";
import { getprovinceByCountry } from "../../redux/Apislices/provinceSlice";
import { getcityByProvince } from "../../redux/Apislices/citySlice";
import { getneighbourhoodByCity } from "../../redux/Apislices/neighbourhoodSlice";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { RSelect } from "../../components/Component";
import { getHomeType } from "../../redux/Apislices/homeTypeSlice";
import { getDevelopmentType } from "../../redux/Apislices/developmentTypeSlice";
import { getInventoryReports, setInventoryFilter } from "../../redux/Apislices/reportSlice";
import { getSaleStatus } from "../../redux/Apislices/saleStatusSlice";

const assignmentStatusOptions = [
  { value: "active", label: "Active" },
  { value: "on hold", label: "On Hold" },
  { value: "sold", label: "Sold" },
  { value: "under contract", label: "Under Contract" },
  { value: "cancelled", label: "Cancelled" },
];

const InventoryForm = ({ handleInventoryGet }) => {
  const dispatch = useDispatch();
  const { countries, provinces, cities, neighbourhoods, homeTypes, saleStatusData, developmentTypes, reports } =
    useSelector((state) => ({
      countries: state.country.countries,
      provinces: state.province.provinceByCountry,
      cities: state.city.cityByProvince,
      neighbourhoods: state.neighbourhood.neighbourhoodByCity,
      homeTypes: state.homeType,
      saleStatusData: state.saleStatus,
      developmentTypes: state.developmentType,
      reports: state.report.inventoryReport,
    }));

  const [country, setCountry] = useState(null);
  const [province, setProvince] = useState(null);
  const [city, setCity] = useState(null);
  const [neighbourhood, setNeighbourhood] = useState(null);
  const [homeType, setHomeType] = useState(null);
  const [buildingType, setBuildingType] = useState(null);
  const [saleStatus, setSaleStatus] = useState(null);
  const [assignmentStatus, setAssignmentStatus] = useState({ value: "active", label: "Active" });
  const [bedroomsMin, setBedroomsMin] = useState(null);
  const [bedroomsMax, setBedroomsMax] = useState(null);
  const [bathroomsMin, setBathroomsMin] = useState(null);
  const [bathroomsMax, setBathroomsMax] = useState(null);

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();

      let payload = {
        country: country?.value,
        province: province?.value,
        city: city?.value,
        neighbourhood: neighbourhood?.value,
        homeType: homeType?.value,
        saleStatus: saleStatus?.value,
        buildingType: buildingType?.value,
        bedroomsMin,
        bedroomsMax,
        bathroomsMin,
        bathroomsMax,
        type: reports.type,
        assignmentStatus: assignmentStatus?.value,
      };
      console.log("payload: ", payload);

      // filter payload and remove empty values or null values or undefined values
      const filteredPayload = Object.keys(payload).reduce((acc, key) => {
        if (payload[key]) {
          acc[key] = payload[key];
        }
        return acc;
      }, {});
      console.log("filteredPayload: ", filteredPayload);

      dispatch(setInventoryFilter(filteredPayload));
      // dispatch(getInventoryReports(filteredPayload));
      // handleInventoryGet(filteredPayload);
    },
    [
      country,
      province,
      city,
      neighbourhood,
      homeType,
      saleStatus,
      buildingType,
      bedroomsMin,
      bedroomsMax,
      bathroomsMin,
      bathroomsMax,
      reports.type,
      dispatch,
    ]
  );

  useEffect(() => {
    dispatch(getCountry());
    dispatch(getHomeType());
    dispatch(getDevelopmentType());
    dispatch(getSaleStatus());
    // dispatch(getInventoryReports());
  }, [dispatch]);

  useEffect(() => {
    if (typeof country === "object" && country?.value) dispatch(getprovinceByCountry(country.value));
    else dispatch(getprovinceByCountry(""));
  }, [country, dispatch]);

  useEffect(() => {
    if (typeof province === "object" && province?.value) dispatch(getcityByProvince(province.value));
    else dispatch(getcityByProvince(""));
  }, [province, dispatch]);

  useEffect(() => {
    if (typeof city === "object" && city?.value) dispatch(getneighbourhoodByCity(city.value));
    else dispatch(getneighbourhoodByCity(""));
  }, [city, dispatch]);

  return (
    <form onSubmit={onSubmit}>
      <Row className={"g-4"}>
        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="country" className="form-label">
              Country
            </Label>
            <div className="form-control-wrap">
              <RSelect
                name="country"
                value={country}
                options={
                  countries?.data?.length
                    ? countries?.data?.map((li) => ({ label: li.name, value: li._id }))
                    : [{ label: "No Countries found", value: "" }]
                }
                isLoading={countries?.loading}
                isClearable
                placeholder="Country"
                onChange={(value) => {
                  setCountry(value);
                }}
              />
            </div>
          </FormGroup>
        </Col>

        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="province" className="form-label">
              Province
            </Label>
            <div className="form-control-wrap">
              <RSelect
                name="province"
                value={province}
                options={
                  provinces?.data?.length
                    ? provinces?.data?.map((li) => ({ label: li.name, value: li._id }))
                    : !country
                    ? [{ label: "Select Country first", value: "" }]
                    : [{ label: "No Provinces found", value: "" }]
                }
                isLoading={provinces?.loading}
                isClearable
                placeholder="Province"
                onChange={(value) => {
                  setProvince(value);
                }}
              />
            </div>
          </FormGroup>
        </Col>

        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="city" className="form-label">
              City
            </Label>
            <div className="form-control-wrap">
              <RSelect
                name="city"
                value={city}
                options={
                  cities?.data?.length
                    ? cities?.data?.map((li) => ({ label: li.name, value: li._id }))
                    : !province
                    ? [{ label: "Select Province first", value: "" }]
                    : [{ label: "No Cities found", value: "" }]
                }
                isLoading={cities?.loading}
                placeholder="City"
                isClearable
                onChange={(value) => {
                  setCity(value);
                }}
              />
            </div>
          </FormGroup>
        </Col>

        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="neighbourhood" className="form-label">
              Neighbourhood
            </Label>
            <div className="form-control-wrap">
              <RSelect
                name="neighbourhood"
                value={neighbourhood}
                options={
                  neighbourhoods?.data?.length
                    ? neighbourhoods?.data?.map((li) => ({ label: li.name, value: li._id }))
                    : !city
                    ? [{ label: "Select City first", value: "" }]
                    : [{ label: "No Neighbourhoods found", value: "" }]
                }
                isLoading={neighbourhoods?.loading}
                isClearable
                placeholder="Neighbourhood"
                onChange={(value) => {
                  setNeighbourhood(value);
                }}
              />
            </div>
          </FormGroup>
        </Col>

        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="home-type" className="form-label">
              Home Type
            </Label>
            <div className="form-control-wrap">
              <RSelect
                name="home-type"
                id="home-type"
                value={homeType}
                options={
                  homeTypes?.homeType?.length
                    ? homeTypes?.homeType?.map((li) => ({ label: li.name, value: li._id }))
                    : [{ label: "No home type found", value: "" }]
                }
                isLoading={homeTypes?.loading}
                placeholder="Home Type"
                onChange={(value) => {
                  setHomeType(value);
                }}
                isClearable
              />
            </div>
          </FormGroup>
        </Col>

        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="building-type" className="form-label">
              Building Type
            </Label>
            <div className="form-control-wrap">
              <RSelect
                name="building-type"
                id="building-type"
                value={buildingType}
                options={
                  developmentTypes?.developmentType?.length
                    ? developmentTypes?.developmentType?.map((li) => ({ label: li.name, value: li._id }))
                    : [{ label: "No building type found", value: "" }]
                }
                isLoading={developmentTypes?.loading}
                placeholder="Building Type"
                onChange={(value) => {
                  setBuildingType(value);
                }}
                isClearable
              />
            </div>
          </FormGroup>
        </Col>

        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="bedrooms-min" className="form-label">
              Bedrooms
            </Label>
            <div className="form-control-wrap">
              <Row className="g-1">
                <Col lg={6} className="">
                  <input
                    type="number"
                    name="bedrooms-min"
                    id="bedrooms-min"
                    value={bedroomsMin}
                    onChange={(e) => {
                      setBedroomsMin(e.target.value);
                    }}
                    placeholder="Min..."
                    className="form-control"
                  />
                </Col>
                <Col lg={6} className="">
                  <input
                    type="number"
                    name="bedrooms-min"
                    id="bedrooms-min"
                    value={bedroomsMax}
                    onChange={(e) => {
                      setBedroomsMax(e.target.value);
                    }}
                    placeholder="Max..."
                    className="form-control"
                  />
                </Col>
              </Row>
            </div>
          </FormGroup>
        </Col>

        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="bathroom-min" className="form-label">
              Bathrooms
            </Label>
            <div className="form-control-wrap">
              <Row className="g-1">
                <Col lg={6} className="">
                  <input
                    type="number"
                    name="bathroom-min"
                    id="bathroom-min"
                    value={bathroomsMin}
                    onChange={(e) => {
                      setBathroomsMin(e.target.value);
                    }}
                    placeholder="Min..."
                    className="form-control"
                  />
                </Col>
                <Col lg={6} className="">
                  <input
                    type="number"
                    name="bathroom-max"
                    id="bathroom-max"
                    value={bathroomsMax}
                    onChange={(e) => {
                      setBathroomsMax(e.target.value);
                    }}
                    placeholder="Max..."
                    className="form-control"
                  />
                </Col>
              </Row>
            </div>
          </FormGroup>
        </Col>

        {reports?.localFilter?.type === "assignment" ? (
          <Col lg={3}>
            <FormGroup>
              <Label htmlFor="assignment-status" className="form-label">
                Assignment Status
              </Label>
              <div className="form-control-wrap">
                <RSelect
                  name="assignment-status"
                  id="assignment-status"
                  value={assignmentStatus}
                  defaultValue={assignmentStatusOptions?.length && assignmentStatusOptions?.[0]}
                  options={
                    assignmentStatusOptions?.length
                      ? assignmentStatusOptions
                      : [{ label: "No assignment status found", value: "" }]
                  }
                  isLoading={assignmentStatusOptions?.loading}
                  placeholder="Assignment Status"
                  onChange={(value) => {
                    setAssignmentStatus(value);
                  }}
                  isClearable
                />
              </div>
            </FormGroup>
          </Col>
        ) : (
          <Col lg={3}>
            <FormGroup>
              <Label htmlFor="sale-status" className="form-label">
                Sale Status
              </Label>
              <div className="form-control-wrap">
                <RSelect
                  name="sale-status"
                  id="sale-status"
                  value={saleStatus}
                  options={
                    saleStatusData?.saleStatus?.length
                      ? saleStatusData?.saleStatus?.map((li) => ({ label: li.name, value: li._id }))
                      : [{ label: "No sale status found", value: "" }]
                  }
                  isLoading={saleStatusData?.loading}
                  placeholder="Sale Status"
                  onChange={(value) => {
                    setSaleStatus(value);
                  }}
                  isClearable
                />
              </div>
            </FormGroup>
          </Col>
        )}

        <Col sm={12}>
          <div style={{ textAlign: "center", marginBottom: "25px" }}>
            <Button type="submit" color="primary">
              Submit
            </Button>
          </div>
        </Col>
      </Row>
    </form>
  );
};

export default InventoryForm;
